import {
  FETCH_VENUES_REQUEST,
  FETCH_VENUES_SUCCESS,
  FETCH_VENUES_FAILURE,
  FETCH_VENUES_DETAILS_FAILURE,
  FETCH_VENUES_DETAILS_REQUEST,
  FETCH_VENUES_DETAILS_SUCCESS,
  FETCH_BOOKINGS_REQUEST,
  FETCH_BOOKINGS_SUCCESS,
  FETCH_BOOKINGS_FAILURE,
  FETCH_BOOKED_STATUS_REQUEST,
  FETCH_BOOKED_STATUS_SUCCESS,
  FETCH_BOOKED_STATUS_FAILURE,
} from "./actionTypes";

const initialState = {
  loading: false,
  venues_list: [],
  totalItems: 0,
  totalPages: 0,
  currentPage: 1,
  itemsPerPage: 10,
  error: "",

  // For single venue details
  venue_details: null,
  loadingDetails: false,
  errorDetails: "",

  // for booking status details
  booking_status_loading: false,
  booking_status_error: "",
  booking_status_data: null,
};

const initialBookingState = {
  loading: false,
  booking_list: [],
  totalItems: 0,
  totalPages: 0,
  currentPage: 1,
  itemsPerPage: 10,
  error: "",
};


export const VenueReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_VENUES_REQUEST:
      return { ...state, loading: true };

    case FETCH_VENUES_SUCCESS:
      return {
        ...state,
        loading: false,
        venues_list: action?.payload?.data,
        totalItems: action?.payload?.totalItems,
        totalPages: action?.payload?.totalPages,
        currentPage: action?.payload?.currentPage,
        itemsPerPage: action?.payload?.itemsPerPage,
        error: "",
      };

    case FETCH_VENUES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // 💡 NEW: Venue Details Reducer
    case FETCH_VENUES_DETAILS_REQUEST:
      return {
        ...state,
        loadingDetails: true,
        errorDetails: "",
        venue_details: null, // Clear previous data
      };

    case FETCH_VENUES_DETAILS_SUCCESS:
      return {
        ...state,
        loadingDetails: false,
        venue_details: action.payload,
      };

    case FETCH_VENUES_DETAILS_FAILURE:
      return {
        ...state,
        loadingDetails: false,
        errorDetails: action.payload,
      };

    // 💡 NEW: booking status Details Reducer
    case FETCH_BOOKED_STATUS_REQUEST:
      return {
        ...state,
        booking_status_loading: true,
        booking_status_error: "",
        booking_status_data: null, // Clear previous data
      };

    case FETCH_BOOKED_STATUS_SUCCESS:
      return {
        ...state,
        booking_status_loading: false,
        booking_status_data: action.payload,
      };

    case FETCH_BOOKED_STATUS_FAILURE:
      return {
        ...state,
        booking_status_loading: false,
        booking_status_error: action.payload,
      };

    default:
      return state;
  }
};

// booking_list,
// loading,
// error,
// totalItems,
// totalPages

export const BookingReducer = (state = initialBookingState, action) => {
  switch (action.type) {
    case FETCH_BOOKINGS_REQUEST:
      return { ...state, loading: true };

    case FETCH_BOOKINGS_SUCCESS:
      return {
        ...state,
        loading: false,
        booking_list: action?.payload?.data || [],
        totalItems: action?.payload?.totalItems || 0,
        totalPages: action?.payload?.totalPages || 0,
        currentPage: action?.payload?.currentPage || 1,
        itemsPerPage: action?.payload?.itemsPerPage || 10,
        error: "",
      };

    case FETCH_BOOKINGS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload || "Something went wrong",
      };

    default:
      return state;
  }
};

